/**
 * Turning an analytics list item into an Aggregated Metrics table row.
 *
 * Kept out of the component so it can be unit tested: the component itself
 * pulls in the whole table feature and cannot be imported in jest.
 */

/** Metrics the table reads off metricsArray, each defaulting to a dash. */
export const AGGREGATED_METRICS_TYPES = [
  "AveragekWhPerKm",
  "MinkWhPerKm",
  "MaxkWhPerKm",
  "AveragekWhPerSoc",
  "MinkWhPerSoc",
  "MaxkWhPerSoc",
  "AverageKmPerSoc",
  "MinKmPerSoc",
  "MaxKmPerSoc",
  "AverageSOH",
  "TotalChargingDurationMinutes",
  "TotalDischargingDurationMinutes",
];

export const buildAggregatedMetricsRow = (item) => {
  const metricsMap = {};
  (item?.metricsArray || []).forEach((m) => {
    metricsMap[m.type] = m.value;
  });

  const metrics = AGGREGATED_METRICS_TYPES.reduce((acc, type) => {
    acc[type] = metricsMap[type] ?? "-";
    return acc;
  }, {});

  return {
    // Every attribute the request asked for, so a column an org configured
    // through metaInfo.FleetPerformance.table renders its value instead of an
    // empty cell. The named fields below carry the dash defaults the existing
    // columns expect and so must stay after the spread.
    ...(item?.metaInfo || {}),
    // Identity, so it comes after the spread: a metaInfo key of any of these
    // names would otherwise replace the row id the table keys rows by.
    id: item?.xLabel,
    key: item?.xLabel,
    batteryID: item?.xLabel,
    deviceID: item?.metaInfo?.deviceID ?? "",
    // Never a dash: the device-id renderer reads pingStatus to colour the
    // connectivity dot and calls toLowerCase() on it.
    pingStatus: item?.metaInfo?.pingStatus ?? null,
    licencePlatNumber: item?.metaInfo?.licencePlatNumber ?? "-",
    originCountry: item?.metaInfo?.originCountry ?? "-",
    originState: item?.metaInfo?.originState ?? "-",
    originCity: item?.metaInfo?.originCity ?? "-",
    originDepot: item?.metaInfo?.originDepot ?? "-",
    ...metrics,
  };
};
